import React from "react";
import { FaSearch } from "react-icons/fa";
import "./ui.css";

export function SearchInput({ value, onChange, placeholder = "Search…", ...rest }) {
  return (
    <div className="ui-search-wrap">
      <FaSearch className="ui-search-icon" aria-hidden="true" />
      <input
        type="text"
        className="ui-search-input"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        {...rest}
      />
    </div>
  );
}

export function FilterSelect({ value, onChange, options, allLabel = "All", ...rest }) {
  return (
    <select className="ui-filter-select" value={value} onChange={onChange} {...rest}>
      <option value="">{allLabel}</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
}

// Row-of-filters shell: desktop lays out inline, mobile wraps cleanly
// (each control keeps its own min-width instead of being forced to stack
// one-per-line).
//
// `className` lets one page opt into its own layout (e.g. a grid) without
// touching the shared rules every other FilterToolbar user relies on.
export function FilterToolbar({ children, className = "" }) {
  return <div className={`ui-filter-toolbar ${className}`.trim()}>{children}</div>;
}
